import * as actionTypes from 'constants/ActionTypes';
import helpers from 'helpers';
import moment from 'moment';
import _ from 'lodash';

const statisticsMonitor = (state = {
    items: [],
    isLoaded: false,
    searchText: '',
    from: '',
    until: '',
}, action) => {
    switch (action.type) {
        case actionTypes.GET_STATISTICS_MONITOR.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_STATISTICS_MONITOR.SUCCESS: {
            return {
                ...state,
                items: action.data,
                isLoaded: true,
            };
        }
        case actionTypes.SEARCH_STATISTICS_MONITOR.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };
        case actionTypes.SEARCH_STATISTICS_MONITOR:
            return {
                ...state,
                searchText: action.searchText,
            };
        default:
            return state;
    }
};

export default statisticsMonitor;



// WEBPACK FOOTER //
// ./app/reducers/statistics/monitor.js